import { useEffect } from 'react';
import ProductGallery from './components/ProductGallery';
import ProductInfo from './components/ProductInfo';
import ProductTabs from './components/ProductTabs';
import RelatedProducts from './components/RelatedProducts';

const ProductPeripheralsPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <nav className="bg-white border-b border-gray-200 sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <a href="/" className="flex items-center gap-3 cursor-pointer">
              <img
                src="https://static.readdy.ai/image/7d05fb9254e2e5292eff42edf988a3d0/d0e0e0e0e0e0e0e0e0e0e0e0e0e0e0e0.png"
                alt="에코브이 로고"
                className="h-10 w-auto object-contain"
              />
            </a>
            <div className="flex items-center gap-6">
              <a href="/" className="text-sm text-gray-700 hover:text-teal-600 transition-colors whitespace-nowrap cursor-pointer">
                홈
              </a>
              <a href="/#products" className="text-sm text-gray-700 hover:text-teal-600 transition-colors whitespace-nowrap cursor-pointer">
                제품
              </a>
              <a href="/#contact" className="text-sm text-gray-700 hover:text-teal-600 transition-colors whitespace-nowrap cursor-pointer">
                문의
              </a>
            </div>
          </div>
        </div>
      </nav>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="flex items-center gap-2 text-sm text-gray-500 mb-8">
          <a href="/" className="hover:text-teal-600 transition-colors cursor-pointer">홈</a>
          <i className="ri-arrow-right-s-line w-4 h-4 flex items-center justify-center"></i>
          <a href="/#products" className="hover:text-teal-600 transition-colors cursor-pointer">제품</a>
          <i className="ri-arrow-right-s-line w-4 h-4 flex items-center justify-center"></i>
          <span className="text-gray-900">주변기기</span>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-16">
          <ProductGallery />
          <ProductInfo />
        </div>

        <div className="mb-16">
          <ProductTabs />
        </div>

        <div className="mb-16">
          <RelatedProducts />
        </div>
      </div>

      <footer className="bg-gray-50 border-t border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
            <div>
              <img
                src="https://static.readdy.ai/image/7d05fb9254e2e5292eff42edf988a3d0/d0e0e0e0e0e0e0e0e0e0e0e0e0e0e0e0.png"
                alt="에코브이 로고"
                className="h-10 w-auto object-contain mb-4"
              />
              <p className="text-sm text-gray-600 leading-relaxed">
                컴퓨터 주변기기 및 정보보안 제품 전문 기업
              </p>
            </div>
            <div>
              <h3 className="text-sm font-bold text-gray-900 mb-4">빠른 링크</h3>
              <ul className="space-y-2">
                <li>
                  <a href="/#products" className="text-sm text-gray-600 hover:text-teal-600 transition-colors cursor-pointer">
                    제품 카테고리
                  </a>
                </li>
                <li>
                  <a href="/#partners" className="text-sm text-gray-600 hover:text-teal-600 transition-colors cursor-pointer">
                    파트너사
                  </a>
                </li>
                <li>
                  <a href="/#contact" className="text-sm text-gray-600 hover:text-teal-600 transition-colors cursor-pointer">
                    문의하기
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <h3 className="text-sm font-bold text-gray-900 mb-4">연락처</h3>
              <ul className="space-y-2 text-sm text-gray-600">
                <li className="flex items-start gap-2">
                  <i className="ri-phone-line text-teal-600 mt-0.5 w-4 h-4 flex items-center justify-center"></i>
                  <span>02-702-0999</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-mail-line text-teal-600 mt-0.5 w-4 h-4 flex items-center justify-center"></i>
                  <span>ecov2025@naver.com</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-global-line text-teal-600 mt-0.5 w-4 h-4 flex items-center justify-center"></i>
                  <span>www.eco-v.co.kr</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-map-pin-line text-teal-600 mt-0.5 w-4 h-4 flex items-center justify-center"></i>
                  <span>서울시 용산구 새창로 181 선인상가 21동 4층 4086호</span>
                </li>
              </ul>
            </div>
          </div>
          <div className="border-t border-gray-200 pt-8">
            <div className="flex flex-col md:flex-row justify-between items-center gap-4">
              <p className="text-sm text-gray-600">
                &copy; 2024 (주)에코브이. All rights reserved. | 대표자: 박종석 | 사업자등록번호: 110111-0921242
              </p>
              <a
                href="https://readdy.ai/?ref=logo"
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm text-gray-500 hover:text-teal-600 transition-colors cursor-pointer"
              >
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default ProductPeripheralsPage;